var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_239_33585",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_239_33585)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.33333H24V0H0V5.33333Z",
    fill: "#FF202D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14307 4.26667L9.71449 3.73334L10.2859 4.26667V5.33334H9.14307V4.26667ZM11.4288 4.26667L12.0002 3.73334L12.5716 4.26667V5.33334H11.4288V4.26667ZM14.2859 3.73334L13.7145 4.26667V5.33334H14.8574V4.26667L14.2859 3.73334Z",
    fill: "#1895DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8571 3.73334L10.2856 4.26667V5.33334H11.4285V4.26667L10.8571 3.73334ZM13.1428 3.73334L12.5714 4.26667V5.33334H13.7142V4.26667L13.1428 3.73334Z",
    fill: "#191F94"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16H24V10.6667H0V16Z",
    fill: "#2027AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2859 5.33331H9.71449L9.14307 6.39998H10.2859V5.33331ZM11.4288 5.33331H12.5716V6.39998H11.4288V5.33331ZM13.7145 5.33331H14.2859L14.8574 6.39998H13.7145V5.33331ZM10.2859 6.39998H11.4288V7.46665H10.2859V6.39998ZM10.2859 7.46665L10.2859 8.53331H9.14307V7.46664L10.2859 7.46665ZM13.7145 6.39998H12.5716V7.46664H11.4288V8.53331H12.5716V7.46665H13.7145L13.7145 8.53331H14.8574V7.46664L13.7145 7.46665V6.39998ZM12.5716 8.53331H13.7145V9.59998H12.5716V8.53331ZM10.2859 8.53331H11.4288V9.59998H10.2859V8.53331ZM10.2859 10.6667V9.59998H9.14307V10.6667H10.2859ZM10.2859 10.6667L10.2859 11.7333H11.4288V10.6666L10.2859 10.6667ZM11.4288 9.59998H12.5716V10.6667H11.4288V9.59998ZM13.7145 10.6667L13.7145 11.7333H12.5716L12.5716 10.6667H13.7145ZM13.7145 10.6667V9.59998H14.8574V10.6667H13.7145Z",
    fill: "url(#paint0_linear_239_33585)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_239_33585",
    x1: 9.14307,
    y1: 5.33331,
    x2: 9.14307,
    y2: 11.7333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF212E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD0D1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/HR.35304c13e73c884dc1ffad2f5eaa3e91.svg";
export { ForwardRef as ReactComponent };